import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import { Button, Typography } from '@mui/material';
import { deleteAccount } from 'api/services/account';
import { logout } from 'api/services/firebase';
import { useModalContext } from 'components/system/ModalContext';
import withNotification from 'components/hoc/withNotification';
import useAccountStore from 'store/accountStore';
import { roles } from 'constants/permissions';
import colors from 'styles/colors';
import AccountDeactivateConfirmation from './AccountDeactivateConfirmation';

const AccountDeactivate = ({ showErrorNotification }) => {
  const { openModal, closeModal } = useModalContext();

  const teamRole = useAccountStore(
    (state) => state.account.team?.teamRole,
  );
  const isOwner = teamRole === roles.teamOwner;

  const navigate = useNavigate();

  const handleDeleteConfirm = async () => {
    try {
      await deleteAccount();
      closeModal();
      await logout();
      navigate('/');
    } catch {
      showErrorNotification('Failed to deactivate the account, please try again later.');
    }
  };

  const handleDeleteClick = () => {
    openModal({
      content: (
        <AccountDeactivateConfirmation
          onCancel={closeModal}
          onClose={closeModal}
          onConfirm={handleDeleteConfirm}
        />
      ),
    });
  };

  return (
    <Box>
      <Box
        sx={{
          borderBottom: '0',
          padding: '24px 0',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ maxHeight: '76px' }}>
          <Typography
            variant="h5"
            sx={{ color: colors.text.primary }}
          >
            Deactivate your account
          </Typography>

        </Box>
        <Button
          disabled={isOwner}
          variant="outlined"
          onClick={handleDeleteClick}
        >
          Deactivate
        </Button>
      </Box>
      {isOwner && (
        <Typography
          variant="cell"
          sx={{ color: colors.text.secondary, display: 'block', textAlign: 'right' }}
        >
          Team owners cannot deactivate their accounts. Please contact our team for assistance.
        </Typography>
      )}
    </Box>
  );
};

export default withNotification(AccountDeactivate);
